export default __webpack_public_path__ + "static/media/facebook.64835acf.svg";